import { render, staticRenderFns } from "./application-disclaimers.vue?vue&type=template&id=5157be48"
import script from "./application-disclaimers.vue?vue&type=script&lang=js"
export * from "./application-disclaimers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports